import { render, staticRenderFns } from "./ThOrdenado.vue?vue&type=template&id=95d64e32"
import script from "./ThOrdenado.vue?vue&type=script&lang=js"
export * from "./ThOrdenado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports